import {Component, Input, OnInit} from '@angular/core';
import {Action} from '@app/shared/components/action/action.model';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html'
})
export class ToolbarComponent implements OnInit {

  @Input() actions: Action[];

  constructor() {
  }

  ngOnInit() {
  }
}
